/* eslint-disable no-console */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Layout, Main } from '../AdminTeamCreation/styles';
import ActivityCategory from './activityCategories';
import BehaviorCategory from './behaviorCategories';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import { fetchChallengeTypeCount, fetWellbeingCategories } from '../../redux/actions';
import _ from 'lodash';
import Waiting from '../Waiting';
import {TabBottomLine, TabWrapper, BorderBottom, Heading} from '../RecogntionAdmin/styles'
import { BrandingTabContainer, BrandingTab } from '../common/commonStyles';
import {AdminCategories, AddIconBranding} from '../../utils/icons'
import HoverButton from '../common/HoverButton'

class ChallengesCategory extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedTabId: 1,
      selectedTab: this.props.history.location && this.props.history.location.query && this.props.history.location.query.isCategory ? 2 : 1,
      hoverButton: false
    }
  }

  componentDidMount() {
    this.props.fetchChallengeTypeCount();
  }

  redirection = () => {
    const { history } = this.props;
    history.push('/company/challenges/create-activty')
  };

  showPastEvents = (path) => {
    this.props.history.push(path);
  };

  onCloseTab = (value) => {
    this.setState({
      selectedTab: value
    })
    if(value===2){
      this.props.fetWellbeingCategories()
    }
  };

  onHover = (value) => {
    this.setState({
      hoverButton: value
    })
  };

  render() {
    const { history, activityChallengeType, wellbeingCategoriesData, role, t,brandingColor } = this.props;
    const { selectedTab } = this.state;
    if (_.isNull(activityChallengeType)|| _.isUndefined(activityChallengeType)) {
      return <Waiting />
    }
    // let getColor = "rgba(243, 122, 101, 1)"

    let getColor = brandingColor ? brandingColor : "rgba(243, 122, 101, 1)"
    return (
      <Layout>
        <Main>
          {
            <BrandingTabContainer isCompare={"0px"}>
              <div className='wrapper'>
                <BrandingTab background={getColor ? getColor : "#0b4170"} active={false} onClick={() => this.showPastEvents(history.location.pathname.includes("/company/challenges/")?'/company/challenges':'/challenges')}>
                  Snapshot
                </BrandingTab>
                <BrandingTab background={getColor ? getColor : "#0b4170"} active={false} onClick={() => this.showPastEvents(history.location.pathname.includes("/company/challenges/")?'/company/challenges/completed':'/challenges/completed')}>
                  Completed
                </BrandingTab>
                <BrandingTab background={getColor ? getColor : "#0b4170"} active={true} >
                  Library
                </BrandingTab>
              </div>
              <div className='rightSection'>
                {role=="ADMIN"&&<div className='compare'>
                  <HoverButton
                    title={"Create Challenge"}
                    svgPath={<AddIconBranding/>}
                    activeColor={"#F37A65"}
                    inActiveColor={"#F37A65"}
                    backgroundColor={"white"}
                    backgroundColorActive={"#F37A65"}
                    onClick={selectedTab===1?history.location.pathname.includes("/company/challenges/categories")?() => history.push('/company/challenges/create-activty'):() => history.push('/challenges/create-activty'):history.location.pathname.includes("/company/challenges/categories")?() => history.push('/company/challenges/create-behavior'):() => history.push('/challenges/create-behavior') }
                    width={"24px"}
                    height={"24px"}
                    fillOpacity={1}
                  />
                </div>}
              </div>
            </BrandingTabContainer>
          }
          <TabWrapper>
            <TabBottomLine active={selectedTab===1} background={getColor} onClick={() => this.onCloseTab(1)}>
              {t("Activity")}
              <BorderBottom active={selectedTab===1} background={getColor} />
            </TabBottomLine>
            <TabBottomLine active={selectedTab===2} background={getColor} onClick={() => this.onCloseTab(2)}>
              {t("Wellness")}
              <BorderBottom active={selectedTab===2} background={getColor} />
            </TabBottomLine>
          </TabWrapper>
          <Heading isMargin={"0px 0px 20px 0px"}>
            <div className='icon'>
              {AdminCategories()}
            </div>
              Explore Categories
          </Heading>
          {/* {role=="ADMIN"&&<CreateChallengeButton active={hoverButton==true} onMouseEnter={() => this.onHover(true)}  onMouseLeave={() => this.onHover(false)} onClick={selectedTab===1?history.location.pathname.includes("/company/challenges/categories")?() => history.push('/company/challenges/create-activty'):() => history.push('/challenges/create-activty'):history.location.pathname.includes("/company/challenges/categories")?() => history.push('/company/challenges/create-behavior'):() => history.push('/challenges/create-behavior') }>
              <div className='image'>
                <CreateChallengeIcon/>
              </div>
              <div className='text'>
                {t("Create Challenge")}
              </div>
            </CreateChallengeButton>} */}
          {selectedTab===1?<ActivityCategory history={history} activityChallengeType={activityChallengeType} role={role}/>:
            <BehaviorCategory history={history} wellbeingCategoriesData={wellbeingCategoriesData.slice(0, 6)} role={role}/>}
        </Main>
      </Layout>
    );
  }
}

ChallengesCategory.propTypes = {
  history: PropTypes.object,
  role: PropTypes.string,
  fetchChallengeTypeCount: PropTypes.func,
  activityChallengeType: PropTypes.array,
  fetWellbeingCategories: PropTypes.func,
  wellbeingCategoriesData: PropTypes.array,
  t: PropTypes.func,
  brandingColor:PropTypes.string,
};

const mapStateToProps = (state) => ({
  activityChallengeType: state.challenges.activityChallengeType,
  wellbeingCategoriesData: state.adminReports.wellbeingCategoriesData,
  brandingColor:state.wellnessDashboard.brandingColor,
})

const mapDispatchToProps = (dispatch) => ({
  fetchChallengeTypeCount: () => dispatch(fetchChallengeTypeCount()),
  fetWellbeingCategories: () => dispatch(fetWellbeingCategories())
})  

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(ChallengesCategory));
